import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';
import ComingSoonPage from './pages/ComingSoonPage';
import ContactPage from './pages/ContactPage';
import DemoPage from './pages/DemoPage';
import SignupPage from './pages/SignupPage';
import ArchitecturePage from './pages/ArchitecturePage';
import OnboardingPage from './pages/OnboardingPage';
import EmployeesPage from './pages/EmployeesPage';
import GovernanceDashboardPage from './pages/GovernanceDashboardPage';
import Dashboard from './pages/Dashboard';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // If there's a hash, scroll to the element
      setTimeout(() => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Otherwise scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <div className="min-h-screen bg-cao-dark text-white">
      <ScrollToTop />
      <Header />

      <main className="relative z-10">
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Functional Pages */}
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/architecture" element={<ArchitecturePage />} />

          {/* Digital Employee Pages */}
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/employees/:id" element={<EmployeesPage />} />

          {/* Governance Dashboard */}
          <Route path="/governance" element={<GovernanceDashboardPage />} />

          {/* Org Chart POC Dashboard */}
          <Route path="/poc" element={<Dashboard />} />

          {/* Coming Soon Pages */}
          <Route path="/docs" element={<ComingSoonPage title="Documentation" description="Comprehensive guides, API references, and tutorials." />} />
          <Route path="/api" element={<ComingSoonPage title="API Reference" description="Full REST and GraphQL API documentation." />} />
          <Route path="/roadmap" element={<ComingSoonPage title="Product Roadmap" description="See what's coming to the CAO Platform." />} />
          <Route path="/careers" element={<ComingSoonPage title="Careers" description="Join us in building the future of AI governance." />} />
          <Route path="/blog" element={<ComingSoonPage title="Blog" description="Insights on AI governance, safety, and alignment." />} />
          <Route path="/press" element={<ComingSoonPage title="Press Kit" description="Media resources and press materials." />} />
          <Route path="/help" element={<ComingSoonPage title="Help Center" description="Support articles and FAQ." />} />
          <Route path="/community" element={<ComingSoonPage title="Community" description="Join the CAO Platform community." />} />
          <Route path="/status" element={<ComingSoonPage title="System Status" description="Real-time platform status and uptime." />} />
          <Route path="/changelog" element={<ComingSoonPage title="Changelog" description="Product updates and release notes." />} />
          <Route path="/partners" element={<ComingSoonPage title="Partners" description="Partner program and integrations." />} />

          {/* Legal Pages */}
          <Route path="/privacy" element={<ComingSoonPage title="Privacy Policy" description="How we handle and protect your data." />} />
          <Route path="/terms" element={<ComingSoonPage title="Terms of Service" description="Terms and conditions for using our services." />} />
          <Route path="/security" element={<ComingSoonPage title="Security" description="Our security practices and certifications." />} />
          <Route path="/compliance" element={<ComingSoonPage title="Compliance" description="Enterprise compliance documentation." />} />
          <Route path="/gdpr" element={<ComingSoonPage title="GDPR" description="EU data privacy compliance information." />} />
          <Route path="/cookies" element={<ComingSoonPage title="Cookie Policy" description="How we use cookies on our website." />} />
          <Route path="/accessibility" element={<ComingSoonPage title="Accessibility" description="Our commitment to accessibility." />} />
          <Route path="/sitemap" element={<ComingSoonPage title="Sitemap" description="Navigate our website." />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
